import { useSelector } from "react-redux";

import {
  useRbacPermissions as useRbacPermissionsCore,
  isRbacFlagOn,
  toBearerHeader,
  RBAC_FLAG_KEY
} from "@lt-web-platform/test-page-components";

// Thin ml adapter for the shared useRbacPermissions hook -- reads userId,
// bearer token and the FF state from Redux, then delegates to the shared
// implementation in @lt-web-platform/test-page-components.
export default function useRbacPermissions() {
  const userInfo = useSelector(state => state?.userInfo?.userInfo);
  const authToken = useSelector(state => state?.auth?.token);
  const featureFlags = useSelector(
    state => state?.userInfo?.featureFlags?.data || null
  );

  const userId = userInfo?.data?.id || userInfo?.data?.user_id || null;
  const authHeader = toBearerHeader(authToken);
  const flagOn = isRbacFlagOn(featureFlags?.[RBAC_FLAG_KEY]);

  return useRbacPermissionsCore({ userId, authHeader, flagOn });
}
